import React, { useEffect, useState } from "react";
import { API } from "aws-amplify";
import { useParams } from "react-router-dom";
import moment from "moment";

import logo from "../static/images/tksl-logo.png";

function Video(props) {
  const params = useParams();
  const [videoLink, setVideoLink] = useState();
  const [redirectAttempted, setRedirectAttempted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    getVideoLink();
  }, []);

  const getVideoLink = async () => {
    if (!videoLink) {
      console.log("Calling API");
      let videoLink = await API.get("api", `/videoLink/${params.id}`);
      setVideoLink(videoLink);
      if (videoLink.youtubeUrl) {
        window.location.href = videoLink.youtubeUrl;
      } else if (videoLink.videoCode === 2) {
        const interval = setInterval(() => {
          setCurrentTime(new Date());
          if (videoLink) {
            if (
              moment(new Date()) > moment(videoLink.premiereTime) &&
              !redirectAttempted
            ) {
              setRedirectAttempted(true);
              retryVideoLink();
            }
          }
        }, 1000);
      }
      setIsLoading(false);
    }
  };

  const retryVideoLink = async () => {
    console.log("Calling API");
    let videoLink = await API.get("api", `/videoLink/${params.id}`);
    setVideoLink(videoLink);
    if (videoLink.youtubeUrl) {
      window.location.href = videoLink.youtubeUrl;
    }
  };

  const renderVideo = () => {
    if (!videoLink) {
      return (
        <div className="m-3">
          <h2>Loading Video...</h2>
        </div>
      );
    } else {
      if (videoLink.videoCode === 0) {
        // not found
        return (
          <div>
            <div className="m-3">
              <h2>Video Not Found</h2>
            </div>
            <div className="m-1">
              A video for this link was not found: it has either been removed or
              this link is not correct.
            </div>
            <div className="m-1">
              Any issues feel free to contact us at{" "}
              <a href="mailto:tksl@goodfortunetrust.org">
                tksl@goodfortunetrust.org
              </a>
            </div>
          </div>
        );
      } else if (videoLink.videoCode === 1) {
        // found
        return (
          <div>
            <div className="m-3">
              <h2>Redirecting to YouTube...</h2>
            </div>
            <div className="m-1">
              If the redirect doesn't work try this link{" "}
              <a href={videoLink.youtubeUrl}>{videoLink.youtubeUrl}</a>
            </div>
            <div className="m-1">
              Any issues feel free to contact us at{" "}
              <a href="mailto:tksl@goodfortunetrust.org">
                tksl@goodfortunetrust.org
              </a>
            </div>
          </div>
        );
      }
      if (videoLink.videoCode === 2) {
        // too early
        return (
          <div>
            <div className="m-3">
              <h2>Video Will Start After Scheduled Time</h2>
            </div>
            <div className="m-1">
              This video will be available for viewing soon.
            </div>
            <div className="m-1">
              This page will automatically redirect you after Brisbane Time:{" "}
              {moment(videoLink.premiereTime)
                .utcOffset(10)
                .format("DD/MM/YYYY h:mm A")}
            </div>
            <div className="m-1">
              Current Brisbane Time:{" "}
              {moment(currentTime).utcOffset(10).format("DD/MM/YYYY h:mm:ss A")}
            </div>
            <div className="m-1">
              Any issues feel free to contact us at{" "}
              <a href="mailto:tksl@goodfortunetrust.org">
                tksl@goodfortunetrust.org
              </a>
            </div>
          </div>
        );
      }
      if (videoLink.videoCode === 3) {
        // expired
        return (
          <div>
            <div className="m-3">
              <h2>Viewing Time Expired</h2>
            </div>
            <div className="m-1">The link to this video has now expired.</div>
            <div className="m-1">
              Any issues feel free to contact us at{" "}
              <a href="mailto:tksl@goodfortunetrust.org">
                tksl@goodfortunetrust.org
              </a>
            </div>
          </div>
        );
      } else {
        return (
          <div>
            Server error when finding video - contact tksl@goodfortunetrust.org
          </div>
        );
      }
    }
  };

  return (
    <div className="container-fluid text-center">
      <div className="d-flex justify-content-center">
        <img alt="" src={logo} />
      </div>
      <div className="d-flex justify-content-center">{renderVideo()}</div>
    </div>
  );
}

export default Video;
